module.exports = __webpack_public_path__ + "img/websitePerformance.e241e7ce.png";